function publicUrl(value: string | undefined, fallback: string): string {
  let url = (value || fallback).trim().replace(/\/$/, '');
  // Coolify can bake an http API host into the bundle. An https page then
  // refuses the request as mixed content, so upgrade when the visitor is already
  // on TLS. Local http://localhost.rallyshift.io keeps talking to http.
  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && url.startsWith('http://')) {
    url = `https://${url.slice('http://'.length)}`;
  }
  return url;
}

/** Where the marketing site hands visitors over to the product. */
export const PORTAL_URL = publicUrl(
  process.env.REACT_APP_PORTAL_URL,
  'https://app.rallyshift.io',
);

/** The volunteer app. The `/us/` storefront redirects visitors to their own. */
export const APP_STORE_URL = 'https://apps.apple.com/us/app/rallyshift/id6816444444';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=io.rallyshift.app';

/** The backend that serves organisation signup and slug availability. */
export const API_URL = (() => {
  const url = publicUrl(process.env.REACT_APP_API_URL, 'https://api.rallyshift.io/api');
  return url.endsWith('/api') ? url : `${url}/api`;
})();
